import { NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SentanceCasePipe } from '@ml/shared/pipes';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
import * as i2 from "@ngx-translate/core";
import * as i3 from "../pipes/sentance-case/sentance-case.pipe";
var SharedService = /** @class */ (function () {
    function SharedService(snackBar, translate, sentenceCase, zone) {
        this.snackBar = snackBar;
        this.translate = translate;
        this.sentenceCase = sentenceCase;
        this.zone = zone;
    }
    SharedService.prototype.showMessage = function (message, interpolateParams, duration, action, panelClass) {
        var _this = this;
        if (interpolateParams === void 0) { interpolateParams = null; }
        if (duration === void 0) { duration = 2000; }
        if (action === void 0) { action = ''; }
        var _action = null;
        if (action) {
            _action = this.translate.instant(action);
        }
        this.translate.get(message, interpolateParams).subscribe(function (text) {
            return _this.zone.run(function () {
                _this.snackBar.open(_this.sentenceCase.transform(text), _action, {
                    duration: duration,
                    panelClass: panelClass
                });
            });
        });
    };
    SharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SharedService_Factory() { return new SharedService(i0.ɵɵinject(i1.MatSnackBar), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.SentanceCasePipe), i0.ɵɵinject(i0.NgZone)); }, token: SharedService, providedIn: "root" });
    return SharedService;
}());
export { SharedService };
